import { authorized } from 'app/request/user'
import { User } from 'app/types/authorization'
import { Auth } from 'aws-amplify'

export const clientUserFromCognito = async (): Promise<User | undefined> => {
  const idToken = await clientGetIdToken()
  if (!idToken) {
    return undefined
  }
  const user = await authorized(idToken)
  if (!user) {
    return undefined
  }
  return user
}

export const clientUserFromIdToken = async (
  idToken: string | undefined
): Promise<User | undefined> => {
  if (!idToken) {
    return undefined
  }
  const user = await authorized(idToken)
  if (!user) {
    return undefined
  }
  return user
}

export const clientGetIdToken = async (): Promise<string | undefined> => {
  try {
    const currentSession = await Auth.currentSession()
    if (!currentSession) {
      return undefined
    }
    const idToken = currentSession.getIdToken().getJwtToken()
    if (!idToken) {
      return undefined
    }
    return idToken
  } catch {
    return undefined
  }
}
